import * as React from "react";
import { forwardRef } from "react";
const SvgLiveCircle = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("circle", { id: "Ellipse 1225", cx: "50%", cy: "50%", r: 3, fill: "#EA0029" }));
const ForwardRef = forwardRef(SvgLiveCircle);
export default ForwardRef;
